import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Popup, Loader } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import Confirm from '../../components/elements/Confirm'
import SearchField from '../../components/elements/SearchField'
import ListSelector from '../../components/elements/ListSelector'
import Properties from '../../components/elements/Properties'
import Details from '../../components/elements/Details'
import CheckboxInput from '../../components/elements/forms/CheckboxInput'
import UpdateProductFullPopup from '../popups/products/UpdateProductFullPopup'
import CreateItemPopup from '../popups/items/CreateItemPopup'
import UpdateItemPopup from '../popups/items/UpdateItemPopup'
import HistoryItemPopup from '../popups/items/HistoryItemPopup'
import CreateMaintenancePopup from '../popups/maintenances/CreateMaintenancePopup'
import Grant from '../elements/Grant'

import ListAction from '../../actions/products/ListAction'
import GetAction from '../../actions/products/GetFullAction'
import PrintAction from '../../actions/print/PrintProductAction'
import DeleteItemAction from '../../actions/items/DeleteAction'
import ChangePageAction from '../../actions/app/ChangePageAction'

const ITEMSVIEW = {
  INDIVIDUAL: 'individual',
  BYLOCATION: 'bylocation'
}

const ALERTS = {
  tocheck: "à mettre en ordre",
  maintenance: "maintenance en retard",
  inventory: "pièces manquantes dans l'inventaire"
}

class ProductsViewPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      // Search text of the right search field
      search: '',
      // Alerts to be displayed
      alerts: {
        tocheck: true,
        inventory: true,
        maintenance: true
      },
      // Is editing product infos
      productUpdate: false,
      // Selected view for items pane
      itemsView: ITEMSVIEW.INDIVIDUAL,
      // Show deleted items in items pane
      itemsShowDeleted: false,
      // Is ItemCreatePopup open ?
      itemCreate: false,
      // ID of item currently open in history popup
      itemHistoryId: null,
      // ID of being-updated item in ItemUpdatePopup
      itemUpdateId: null,
      // ID of being-deleted item
      itemDeleteId: null,
      // Is MaintenanceCreatePopup open ?
      maintenanceCreate: false,
    }

    // Bind events
    this.onSelect = this.onSelect.bind(this)
    this.onClickManage = this.onClickManage.bind(this)
    this.onChangeSearch = this.onChangeSearch.bind(this)
    this.onChangeCheckboxAlertsTocheck = this.onChangeCheckboxAlertsTocheck.bind(this)
    this.onChangeCheckboxAlertsInventory = this.onChangeCheckboxAlertsInventory.bind(this)
    this.onChangeCheckboxAlertsMaintenance = this.onChangeCheckboxAlertsMaintenance.bind(this)
    this.onClickProductUpdate = this.onClickProductUpdate.bind(this)
    this.onCloseProductUpdate = this.onCloseProductUpdate.bind(this)
    this.onClickProductPrint = this.onClickProductPrint.bind(this)
    this.onChangeItemsView = this.onChangeItemsView.bind(this)
    this.onChangeItemsShowDeleted = this.onChangeItemsShowDeleted.bind(this)
    this.onClickItemCreate = this.onClickItemCreate.bind(this)
    this.onCloseItemCreate = this.onCloseItemCreate.bind(this)
    this.onClickItemHistory = this.onClickItemHistory.bind(this)
    this.onCloseItemHistory = this.onCloseItemHistory.bind(this)
    this.onClickItemUpdate = this.onClickItemUpdate.bind(this)
    this.onCloseItemUpdate = this.onCloseItemUpdate.bind(this)
    this.onClickItemDelete = this.onClickItemDelete.bind(this)
    this.onConfirmItemDelete = this.onConfirmItemDelete.bind(this)
    this.onClickMaintenanceCreate = this.onClickMaintenanceCreate.bind(this)
    this.onCloseMaintenanceCreate = this.onCloseMaintenanceCreate.bind(this)
    this.onClickMaintenanceSelect = this.onClickMaintenanceSelect.bind(this)
    this.onClickExecutionSelect = this.onClickExecutionSelect.bind(this)
  }

  fetchList() {
    this.props.fetchList()
  }

  fetchOne() {
    this.props.fetchOne(this.props.selected)
  }

  setAlerts(alerts = {}) {
    this.setState((prevState, props) => (_.extend(
      {},
      prevState,
      {
        alerts: _.extend(
          {},
          prevState.alerts,
          alerts
        )
      }
    )))
  }

  componentDidMount() {
    this.fetchList()
    if (!_.isNull(this.props.selected)) {
      this.fetchOne()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // After selecting a product, load details
    if (
      prevProps.selected !== this.props.selected
      &&
      !_.isNull(this.props.selected)
    ) {
      this.fetchOne()
    }

    // After an item has been deleted, refresh
    if (
      prevProps.deleteIsFecthing
      &&
      !this.props.deleteIsFecthing
    ) {
      this.setState({
        itemDeleteId: null
      })
      AppUtils.setStatus(
        this.props.deleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.deleteError
          ? AppUtils.errorToText(this.props.deleteError)
          : 'Pièce supprimée.'
      )
      if (!this.props.deleteError) {
        this.fetchOne()
      }
    }
  }

  onSelect(selected) {
    this.props.changePage(AppConstants.PAGE.PRODUCTS_VIEW, selected)
  }

  onClickManage() {
    this.props.changePage(AppConstants.PAGE.PRODUCTS_MANAGE)
  }

  onChangeSearch(search) {
    this.setState({ search })
  }

  onChangeCheckboxAlertsTocheck(tocheck) {
    this.setAlerts({ tocheck })
  }

  onChangeCheckboxAlertsInventory(inventory) {
    this.setAlerts({ inventory })
  }

  onChangeCheckboxAlertsMaintenance(maintenance) {
    this.setAlerts({ maintenance })
  }

  onClickProductUpdate() {
    this.setState({
      productUpdate: true
    })
  }

  onCloseProductUpdate(isDirty) {
    this.setState({
      productUpdate: false
    })
    if (isDirty) {
      this.fetchOne()
      this.fetchList()
    }
  }

  onClickProductPrint() {
    this.props.printOne(this.props.selected)
  }

  onChangeItemsView(itemsView) {
    return () => {
      this.setState({ itemsView })
    }
  }

  onChangeItemsShowDeleted(itemsShowDeleted) {
    this.setState({ itemsShowDeleted })
  }

  onClickItemCreate() {
    this.setState({
      itemCreate: true
    })
  }

  onCloseItemCreate(isDirty) {
    this.setState({
      itemCreate: false
    })
    if (isDirty) {
      this.fetchOne()
    }
  }

  onClickItemHistory(itemHistoryId) {
    return () => {
      this.setState({ itemHistoryId })
    }
  }

  onCloseItemHistory() {
    this.setState({
      itemHistoryId: null
    })
  }

  onClickItemUpdate(itemUpdateId) {
    return () => {
      this.setState({ itemUpdateId })
    }
  }

  onCloseItemUpdate(isDirty) {
    this.setState({
      itemUpdateId: null
    })
    if (isDirty) {
      this.fetchOne()
    }
  }

  onClickItemDelete(itemDeleteId) {
    return () => {
      this.setState({ itemDeleteId })
    }
  }

  onConfirmItemDelete(proceed) {
    if (proceed) {
      this.props.deleteItem(this.state.itemDeleteId)
    }
    else {
      this.setState({
        itemDeleteId: null
      })
    }
  }

  onClickMaintenanceCreate() {
    this.setState({
      maintenanceCreate: true
    })
  }

  onCloseMaintenanceCreate(isDirty) {
    this.setState({
      maintenanceCreate: false
    })
    if (isDirty) {
      this.fetchOne()
    }
  }

  onClickMaintenanceSelect(id, row) {
    return () => {
      this.props.changePage(
        row.maintenance
          ? AppConstants.PAGE.MAINTENANCE_VIEW
          : AppConstants.PAGE.CONTROL_VIEW,
        id
      )
    }
  }

  onClickExecutionSelect(maintenanceId, executionId) {
    return () => {
      this.props.changePage(
        AppConstants.PAGE.MAINTENANCE_VIEW,
        maintenanceId,
        executionId
      )
    }
  }

  extractAlerts(product, onlyIfActivated=false) {
    return _.filter(
      _.map(
        product.alerts,
        (val, key) => (
          (
            this.state.alerts[key]
            ||
            !onlyIfActivated
          )
          &&
          val
            ? ALERTS[key]
            : null
        )
      ),
      (val) => (!_.isNull(val))
    )
  }

  render() {
    const filteredList = _.isArray(this.props.listData)
      ? _.filter(
          _.map(
            this.props.listData,
            (category) => (_.extend(
              {},
              category,
              {
                products: _.filter(
                  category.products,
                  (product) => (AppUtils.search(product.name, this.state.search))
                )
              }
            ))
          ),
          (category) => (
            this.state.search.length === 0
            ||
            !_.isEmpty(category.products)
          )
        )
      : null
    const linearList = []
    if (this.props.listIsFetching) {
      linearList.push(
        <ListSelector.Header
          foreground='000000'
          background='ffffff'
          text='Chargement...'
        />
      )
    }
    else {
      if (_.isArray(filteredList) && _.size(filteredList) > 0) {
        _.each(filteredList, (category) => {
          linearList.push(
            <ListSelector.Header
              foreground={category.color.foreground}
              background={category.color.background}
              text={category.name}
            />
          )
          if (_.isEmpty(category.products)) {
            linearList.push(
              <ListSelector.Header
                foreground='000000'
                background='ffffff'
                text='Catégorie vide'
              />
            )
          }
          else {
            _.each(category.products, (product) => {
              const alerts = this.extractAlerts(product, true)
              linearList.push(
                <ListSelector.Item
                  value={product.id}
                  text={product.name}
                  status={
                    _.isEmpty(alerts)
                      ? undefined
                      : <Details
                          icon={Details.ICON.WARNING}
                          action={Details.ACTION.HOVER}
                          content={
                            <React.Fragment>
                              Liste des problèmes :
                              <ul>
                                {
                                  _.map(alerts, (alert) => (
                                    <li key={alert}>{alert}</li>
                                  ))
                                }
                              </ul>
                            </React.Fragment>
                          }
                        />
                  }
                />
              )
            })
          }
        })
      }
      else {
        linearList.push(
          <ListSelector.Header
            foreground='000000'
            background='ffffff'
            text='Rien à afficher.'
          />
        )
      }
    }
    const alerts = !_.isNull(this.props.getData)
      ? this.extractAlerts(this.props.getData, false)
      : null
    const countItemsActive = !_.isNull(this.props.getData)
      ? _.size(_.filter(
          this.props.getData.items,
          (item) => (_.isNull(item.deleted))
        ))
      : 0
    const countItemsDeleted = !_.isNull(this.props.getData)
      ? _.size(_.filter(
          this.props.getData.items,
          (item) => (!_.isNull(item.deleted))
        ))
      : 0
    const itemsByLocation = this.state.itemsView === ITEMSVIEW.BYLOCATION && !_.isNull(this.props.getData)
      ? (
          _.sortBy(
            _.values(
              _.mapObject(
                _.groupBy(
                  this.props.getData.items,
                  (item) => (item.location.id)
                ),
                (items) => {
                  const compartments = (
                    _.map(
                      _.values(
                        _.groupBy(
                          _.map(
                            items,
                            (item) => ({
                              compartment: item.compartment,
                              quantity_active: _.isNull(item.deleted) ? 1 : 0,
                              quantity_deleted: _.isNull(item.deleted) ? 0 : 1
                            })
                          ),
                          (item) => (item.compartment)
                        )
                      ),
                      (group) => _.reduce(
                        group,
                        (acc, compartment) => ({
                          compartment: compartment.compartment,
                          quantity_active: acc.quantity_active + compartment.quantity_active,
                          quantity_deleted: acc.quantity_deleted + compartment.quantity_deleted
                        }),
                        {
                          compartment: null,
                          quantity_active: 0,
                          quantity_deleted: 0
                        }
                      )
                    )
                  )
                  const worstIcon = AppUtils.worstIcon(_.union(
                    [ Details.ICON.INFO ],
                    _.map(
                      _.filter(
                        items,
                        (item) => (_.isNull(item.deleted))
                      ),
                      (item) => (AppUtils.getDetailsInventory(item).icon)
                    ),
                    _.flatten(
                      _.map(
                        _.filter(
                          items,
                          (item) => (_.isNull(item.deleted))
                        ),
                        (item) => (
                          _.map(
                            item.maintenances,
                            (maintenance) => (AppUtils.dateToReminder(maintenance.next).icon)
                          )
                        )
                      )
                    )
                  ))
                  return {
                    location: items[0].location,
                    compartment: _.size(compartments) === 1
                      ? compartments[0].compartment
                      : compartments,
                    quantity_active: _.size(_.filter(
                      items,
                      (item) => (_.isNull(item.deleted))
                    )),
                    quantity_deleted: _.size(_.filter(
                      items,
                      (item) => (!_.isNull(item.deleted))
                    )),
                    icon: worstIcon,
                    items
                  }
                }
              )
            ),
            ({ location: { stickers } }) => _.map(stickers, ({ name }) => name).join('_')
          )
        )
      : null
    const columns = !_.isNull(this.props.getData)
      ? _.union(
          // N° (only if prefixed)
          !_.isNull(this.props.getData.prefix)
            ? [ ColumnsProvider.itemNumber ]
            : [],
          // Emplacement
          _.isNull(itemsByLocation)
            ? [ ColumnsProvider.locationStickersWithLabelStatus(this) ]
            : [],
          [
            // Compartiment
            ColumnsProvider.itemCompartmentBasic,
            // Inventaire
            ColumnsProvider.itemInventory,
            // Maintenance
            ColumnsProvider.itemMaintenance,
            // Remarque
            ColumnsProvider.itemRemark,
            // Ajouté
            ColumnsProvider.itemCreated
          ],
          // Supprimé
          this.state.itemsShowDeleted
            ? [ ColumnsProvider.itemDeleted ]
            : [],
          // Actions
          [
            ColumnsProvider.itemActions(
              _.isNull(itemsByLocation),
              this.onClickItemHistory,
              this.onClickItemUpdate,
              this.onClickItemDelete
            )
          ]
        )
      : []
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='1 1 20%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div
              style={{
                flex: '0 0 38px',
                display: 'flex',
                flexDirection: 'row'
              }}
            >
              <div style={{ flex: '0 1 auto' }}>
                <Popup
                  trigger={
                    <Button
                      icon='edit'
                      onClick={this.onClickManage}
                      style={{ margin: 0 }}
                    />
                  }
                  inverted={true}
                  on='hover'
                  position='right center'
                >
                  Gestion du matériel
                </Popup>
              </div>
              <div style={{
                flex: '1 0 auto',
                margin: '0 8px'
              }}>
                <SearchField
                  value={this.state.search}
                  onChange={this.onChangeSearch}
                />
              </div>
              <div style={{ flex: '0 1 auto' }}>
                <Popup
                  trigger={
                    <Button
                      icon='warning sign'
                      style={{ margin: 0 }}
                    />
                  }
                  flowing={true}
                  on='click'
                  position='bottom right'
                >
                  <div>
                    Alertes affichées
                  </div>
                  <div>
                    <CheckboxInput
                      text='À mettre en ordre'
                      checked={this.state.alerts.tocheck}
                      onChange={this.onChangeCheckboxAlertsTocheck}
                    />
                  </div>
                  <div>
                    <CheckboxInput
                      text='Inventaire'
                      checked={this.state.alerts.inventory}
                      onChange={this.onChangeCheckboxAlertsInventory}
                    />
                  </div>
                  <div>
                    <CheckboxInput
                      text='Maintenance'
                      checked={this.state.alerts.maintenance}
                      onChange={this.onChangeCheckboxAlertsMaintenance}
                    />
                  </div>
                </Popup>
              </div>
            </div>
            <ListSelector
              style={{
                flex: '1 1 auto',
                marginTop: '8px'
              }}
              selected={this.props.selected}
              onSelect={this.onSelect}
              children={linearList}
            />
          </Page.Element>
          <Page.Container
            flex='4 4 80%'
            direction={Page.DIRECTION.COL}
          >
            {
              !_.isNull(this.props.selected)
                ? (
                    this.props.getIsFetching || !this.props.getData
                      ? <Page.Element
                          flex='1 1 100%'
                        >
                          <Loader
                            active={true}
                            content='Chargement...'
                            size='huge'
                          />
                        </Page.Element>
                      : <React.Fragment>
                          <Page.Container
                            flex='0 0 auto'
                            direction={Page.DIRECTION.ROW}
                          >
                            <Page.Element
                              flex='2 2 66%'
                              withBorders={true}
                            >
                              <Header
                                title='Description du matériel'
                                center={
                                  _.isArray(alerts) && !_.isEmpty(alerts)
                                    ? <Details
                                        icon={Details.ICON.WARNING}
                                        action={Details.ACTION.HOVER}
                                        content={
                                          <React.Fragment>
                                            Liste des problèmes :
                                            <ul>
                                              {
                                                _.map(alerts, (alert) => (
                                                  <li key={alert}>{alert}</li>
                                                ))
                                              }
                                            </ul>
                                          </React.Fragment>
                                        }
                                        big={true}
                                      />
                                    : null
                                }
                                right={
                                  <Grant role={Grant.ROLE.MANAGE}>
                                    <Button
                                      compact={true}
                                      icon='pencil'
                                      color='orange'
                                      onClick={this.onClickProductUpdate}
                                    />
                                  </Grant>
                                }
                                alignTop={true}
                              />
                              <Properties
                                content={[
                                  {
                                    key: 'Nom',
                                    value: this.props.getData.name
                                  },
                                  {
                                    key: 'Prix',
                                    value: this.props.getData.price || '-'
                                  },
                                  {
                                    key: 'Fournisseur',
                                    value: this.props.getData.provider || '-'
                                  },
                                  {
                                    key: 'Réparateur',
                                    value: this.props.getData.reparator || '-'
                                  },
                                  {
                                    key: 'Groupe matériel',
                                    value: (
                                      (
                                        this.props.getData.owner
                                        &&
                                        this.props.getData.owner.name
                                      )
                                      ||
                                      '-'
                                    )
                                  },
                                  {
                                    key: (
                                      <React.Fragment>
                                        Préfixe&nbsp;
                                        <Details
                                          icon={Details.ICON.INFO}
                                          action={Details.ACTION.HOVER}
                                          content="Préfixe pour l'étiquettage individuel des pièces"
                                        />
                                      </React.Fragment>
                                    ),
                                    value: this.props.getData.prefix || "(Pas d'étiquettage individuel)"
                                  },
                                  {
                                    key: 'Remarque',
                                    value: this.props.getData.remark || '-'
                                  }
                                ]}
                              />
                            </Page.Element>
                            {
                              this.props.getData
                              &&
                              this.props.getData.specialization
                              &&
                              this.props.getData.specialization.type
                              &&
                              this.props.getData.specialization.type !== AppConstants.PRODUCT.TYPE.NONE
                                ? <Page.Container
                                    flex='1 1 34%'
                                    direction={Page.DIRECTION.COL}
                                  >
                                    {
                                      this.props.getData.specialization.type === AppConstants.PRODUCT.TYPE.PIPE
                                        ? <Page.Element
                                            flex='3 3 60%'
                                            withBorders={true}
                                          >
                                            <Header
                                              title='Informations sur le tuyau'
                                              alignTop={true}
                                            />
                                            <Properties
                                              content={[
                                                {
                                                  key: 'Longueur (en mètres)',
                                                  value: this.props.getData.specialization.pipe_length
                                                },
                                                {
                                                  key: 'Diamètre',
                                                  value: `${this.props.getData.specialization.pipe_diameter.diameter} mm`
                                                },
                                                {
                                                  key: 'Roulé',
                                                  value: this.props.getData.specialization.pipe_separate ? 'Séparément' : 'Dévidoir'
                                                }
                                              ]}
                                            />
                                          </Page.Element>
                                        : null
                                    }
                                    {
                                      this.props.getData.specialization.type === AppConstants.PRODUCT.TYPE.BATTERY
                                        ? <Page.Element
                                            flex='2 2 40%'
                                            withBorders={true}
                                          >
                                            <Header
                                              title='Informations sur les batteries'
                                              alignTop={true}
                                            />
                                            <Properties
                                              content={[
                                                {
                                                  key: 'Modèle',
                                                  value: this.props.getData.specialization.batteries_type.name
                                                },
                                                {
                                                  key: 'Nombre',
                                                  value: this.props.getData.specialization.batteries_count
                                                }
                                              ]}
                                            />
                                          </Page.Element>
                                        : null
                                    }
                                  </Page.Container>
                                : null
                            }
                          </Page.Container>
                          <Page.Element
                            flex='1 1 auto'
                            withBorders={true}
                            style={{
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <Header
                              style={{
                                flex: '0 1 auto'
                              }}
                              title={`Pièces (${countItemsActive})`}
                              center={
                                <React.Fragment>
                                  <Button.Group
                                    compact={true}
                                  >
                                    <Button
                                      content='Individuel'
                                      active={this.state.itemsView === ITEMSVIEW.INDIVIDUAL}
                                      basic={this.state.itemsView !== ITEMSVIEW.INDIVIDUAL}
                                      onClick={this.onChangeItemsView(ITEMSVIEW.INDIVIDUAL)}
                                    />
                                    <Button
                                      content='Par emplacement'
                                      active={this.state.itemsView === ITEMSVIEW.BYLOCATION}
                                      basic={this.state.itemsView !== ITEMSVIEW.BYLOCATION}
                                      onClick={this.onChangeItemsView(ITEMSVIEW.BYLOCATION)}
                                    />
                                  </Button.Group>
                                  <CheckboxInput
                                    style={{
                                      margin: '0 16px'
                                    }}
                                    text='Afficher supprimés'
                                    checked={this.state.itemsShowDeleted}
                                    onChange={this.onChangeItemsShowDeleted}
                                  />
                                  <span style={{ color: 'red' }}>
                                    {`(${countItemsDeleted})`}
                                  </span>
                                </React.Fragment>
                              }
                              right={
                                <React.Fragment>
                                  <Button
                                    compact={true}
                                    icon='print'
                                    color='blue'
                                    onClick={this.onClickProductPrint}
                                  />
                                  <Grant role={Grant.ROLE.MANAGE}>
                                    <Button
                                      compact={true}
                                      icon='plus'
                                      content='Créer'
                                      color='green'
                                      onClick={this.onClickItemCreate}
                                    />
                                  </Grant>
                                </React.Fragment>
                              }
                            />
                            {
                              this.state.itemsView === ITEMSVIEW.INDIVIDUAL
                                ? <Table
                                    columns={columns}
                                    data={
                                      _.filter(
                                        this.props.getData.items,
                                        (item) => (
                                          this.state.itemsShowDeleted
                                          ||
                                          _.isNull(item.deleted)
                                        )
                                      )
                                    }
                                    error={null}
                                    isLoading={false}
                                    emptyMessage="Ce matériel ne possède pas de pièces pour le moment."
                                  />
                                : null
                            }
                            {
                              this.state.itemsView === ITEMSVIEW.BYLOCATION
                                ? <Table
                                    columns={[
                                      // Emplacement
                                      ColumnsProvider.locationStickersWithLabelStatus(this),
                                      // Compartiment
                                      ColumnsProvider.itemCompartmentMultiple(this),
                                      // Quantité
                                      ColumnsProvider.itemQuantityWithDetails(this, columns)
                                    ]}
                                    data={
                                      _.filter(
                                        itemsByLocation,
                                        (group) => (
                                          group.quantity_active > 0
                                          ||
                                          this.state.itemsShowDeleted
                                        )
                                      )
                                    }
                                    error={null}
                                    isLoading={false}
                                    emptyMessage="Ce matériel ne possède pas de pièces pour le moment."
                                  />
                                : null
                            }
                          </Page.Element>
                          <Page.Element
                            flex='0 1 200px'
                            withBorders={true}
                            style={{
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <Header
                              style={{
                                flex: '0 1 auto'
                              }}
                              title='Contrôles et maintenances'
                              right={
                                <Grant role={Grant.ROLE.MANAGE}>
                                  <Button
                                    compact={true}
                                    icon='plus'
                                    content='Créer'
                                    color='green'
                                    onClick={this.onClickMaintenanceCreate}
                                  />
                                </Grant>
                              }
                            />
                            <Table
                              columns={[
                                // Type
                                ColumnsProvider.controlOrMaintenanceType,
                                // Nom
                                ColumnsProvider.controlOrMaintenanceDetails,
                                // Récurrence
                                ColumnsProvider.controlOrMaintenanceRecurrence,
                                // Prochaine
                                ColumnsProvider.controlOrMaintenanceNext,
                                // Actions
                                ColumnsProvider.actionGoTo(
                                  this.onClickMaintenanceSelect,
                                  (row) => (
                                    row.maintenance
                                      ? 'maintenance.id'
                                      : 'control.control.id'
                                  )
                                )
                              ]}
                              data={this.props.getData.maintenances_and_controls}
                              error={null}
                              isLoading={false}
                              emptyMessage="Il n'existe pas de maintenance pour ce matériel pour le moment."
                            />
                          </Page.Element>
                        </React.Fragment>
                  )
                : null
            }
          </Page.Container>
        </Page>
        {
          this.state.productUpdate && !_.isNull(this.props.selected)
            ? <UpdateProductFullPopup
                id={this.props.selected}
                onClose={this.onCloseProductUpdate}
              />
            : null
        }
        {
          !_.isNull(this.state.itemHistoryId) && !_.isNull(this.props.selected)
            ? <HistoryItemPopup
                id={this.state.itemHistoryId}
                onClose={this.onCloseItemHistory}
              />
            : null
        }
        {
          this.state.itemCreate && !_.isNull(this.props.selected)
            ? <CreateItemPopup
                product={_.pick(this.props.getData, 'id', 'name')}
                withNumber={!_.isNull(this.props.getData.prefix)}
                onClose={this.onCloseItemCreate}
              />
            : null
        }
        {
          !_.isNull(this.state.itemUpdateId) && !_.isNull(this.props.selected)
            ? <UpdateItemPopup
                id={this.state.itemUpdateId}
                product={_.pick(this.props.getData, 'id', 'name')}
                withNumber={!_.isNull(this.props.getData.prefix)}
                onClose={this.onCloseItemUpdate}
              />
            : null
        }
        {
          !_.isNull(this.state.itemDeleteId)
            ? <Confirm
                header="Suppression d'une pièce"
                body="Êtes-vous sûr de vouloir supprimer cette pièce ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.deleteIsFecthing}
                callback={this.onConfirmItemDelete}
              />
            : null
        }
        {
          this.state.maintenanceCreate && !_.isNull(this.props.selected)
            ? <CreateMaintenancePopup
                product={this.props.selected}
                onClose={this.onCloseMaintenanceCreate}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

ProductsViewPage.propTypes = {
  // Properties

  // Redux State
  selected: PropTypes.number,
  listData: PropTypes.array,
  listIsFetching: PropTypes.bool.isRequired,
  listError: PropTypes.object,
  getData: PropTypes.object,
  getIsFetching: PropTypes.bool.isRequired,
  getError: PropTypes.object,
  deleteIsFecthing: PropTypes.bool.isRequired,
  deleteError: PropTypes.object,

  // Redux Actions
  fetchList: PropTypes.func.isRequired,
  fetchOne: PropTypes.func.isRequired,
  printOne: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    selected: state.entities.products.view,
    listData: state.entities.products.list.data,
    listIsFetching: state.entities.products.list.isFetching,
    listError: state.entities.products.list.error,
    // Sort items by location and compartment
    getData: _.isNull(state.entities.products.get.full.data)
      ? null
      : {
          ...(state.entities.products.get.full.data),
          items: _.sortBy(
            state.entities.products.get.full.data.items,
            ({ location: { stickers }, compartment }) => {
              const locationStr = _.map(stickers, ({ name }) => name).join('_'),
                    compartmentStr = _.isString(compartment) ? compartment : '';
              return `${locationStr}_${compartmentStr}`;
            }
          )
        },
    getIsFetching: state.entities.products.get.full.isFetching,
    getError: state.entities.products.get.full.error,
    deleteIsFecthing: state.entities.items.delete.isFetching,
    deleteError: state.entities.items.delete.error,
  }),
  (dispatch) => ({
    fetchList: () => (dispatch(ListAction({}))),
    fetchOne: (id) => (dispatch(GetAction({ id }))),
    printOne: (id) => (dispatch(PrintAction({ id }))),
    deleteItem: (id) => (dispatch(DeleteItemAction({ id }))),
    changePage: (page, id=undefined, execution=undefined) => (dispatch(ChangePageAction(page, _.omit({ id, execution }, _.isUndefined))))
  })
)(ProductsViewPage)



// WEBPACK FOOTER //
// ./src/containers/pages/ProductsViewPage.js